<template>
  <div v-show="selfShow">
    <div class="delMessage">
      <h5>
        {{tit}}
        <span @click="call">
          <!-- <img src="../assets/imgs/message/popup_close_normal.png" alt /> -->
        </span>
      </h5>
      <div class="mainText">{{txt}}</div>
      <div class="but" v-show="!interpreterBut">
        <button class="themeCallBut" @click="call">取消</button>
        <button class="themeGoBut"  ref="delEnsureBtn" @click="confirm">确定</button>
      </div>
    </div>
    <div class="hide1" @click="call"></div>
  </div>
</template>

<script>
export default {
  name: "delMessage",
  props: {
    tit: {
      type: String,
      default: "友情提示"
    },
    txt: String,
    isShow: Boolean,
    interpreterBut: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow: {
      immediate: false,
      handler: function () {
        this.selfShow = this.isShow;
        if (this.isShow) {
          this.$refs.delEnsureBtn.focus();
          document.addEventListener("keyup", this.keyUp);
        } else {
          document.removeEventListener("keyup", this.keyUp);
        }
      }
    }
  },
  data () {
    return {
      selfShow: false
    };
  },
  components: {},
  methods: {
    confirm () {
      this.$parent.del();
    },
    call () {
      this.$parent.call();
    },
    keyUp (event) {
      //确定
      if (event.keyCode === 13) {
        this.$parent.del();
      } else if (event.keyCode === 27) {
        this.$parent.call();
      }
      // this.$parent.del();
    }
  }
};
</script>
<style lang="less" scoped>
div {
  .hide1 {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    opacity: 0.7;
    z-index: 888;
  }
}
.delMessage {
  width: 450px;
  min-height: 185px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 8px 0px rgba(76, 76, 76, 0.8);
  border-radius: 10px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  opacity: 1;
  h5 {
    border-bottom: 1px solid #dfe4e8;
      width: 90%;
      margin: 0 auto;
    height: 48px;
    line-height: 48px;
    border-radius: 10px 10px 0px 0px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    // color: rgba(255, 255, 255, 1);
    position: relative;
    text-align: center;
    // background: url("../assets/imgs/memory/popup_background.png");
    span {
      position: absolute;
      right: 10px;
      img {
        cursor: pointer;
        -webkit-transition: -webkit-transform 0.6s ease-out;
        -moz-transition: -moz-transform 0.6s ease-out;
        transition: transform 0.6s ease-out;
      }
      img:hover {
        -webkit-transform: rotate(180deg);
        -moz-transform: rotate(180deg);
        transform: rotate(180deg);
      }
    }
  }
  .mainText {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    width: 450px;
  }
  .but {
    position: absolute;
    bottom: 20px;
    margin: 0 auto;
    left: 50%;
    transform: translate(-50%, 0);
    // padding-bottom: 30px;
    // margin: 0 80px;
    button:nth-child(2) {
      margin-left: 30px;
    }
  }
}
</style>